import { CircularProgress, styled } from "@mui/material";
import colors from "theme/themeConstants";

interface IProps {
  progressPercent?: number | string | null;
  color?: string;
  size?: string;
}

const Preloader = (props: IProps) => {
  const { progressPercent, color = colors.white, size = "1rem" } = props;

  return (
    <Container>
      {progressPercent && <p style={{ color: color }}>{progressPercent}%</p>}
      <CircularProgress sx={{ color: color }} size={size}/>
    </Container>
  );
};

export default Preloader;

const Container = styled("div")({
  display: "flex",
  alignItems: "center",
  gap: "8px",
  color: "white",
  alignSelf: "center"
});
